import { useState, useEffect } from "react";
import { apiUrl } from "utils/api";

const useAllTrendingProducts = () => {
  const [allTrendingProducts, setTenTrendingProducts] = useState([]);
  const [loading1, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewProducts = async () => {
      try {
        // const response = await fetch(`/api/getAllProduct`);
        const response = await fetch(apiUrl("getAllTrendingProduct"));
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setTenTrendingProducts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNewProducts();
  }, []);

  return { allTrendingProducts, loading1, error };
};

export default useAllTrendingProducts;
